import { Component } from '@verndale/core';

class SearchMenu extends Component {
  outsideClickListener: EventListener;
  escapeKeyListener: EventListener;

  constructor(el: HTMLElement) {
    super(el);
    this.outsideClickListener = this.handleOutsideClick.bind(this);
    this.escapeKeyListener = this.handleEscapeKeyPress.bind(this) as EventListener;
  }

  setupDefaults() {
    this.dom = {
      desktopTrigger: this.el.querySelector<HTMLElement>('.search-menu__button'),
      form: this.el.querySelector<HTMLElement>('form.search-menu__desktop-dropdown'),
      input: this.el.querySelector<HTMLInputElement>('.search-menu__input'),
      submitButton: this.el.querySelector<HTMLElement>('button.search-menu__search-button'),
      eraseButton: this.el.querySelector<HTMLElement>('button.search-menu__erase-button'),
    };

    this.enableSubmitButton();
  }

  addListeners() {
    (this.dom.form as HTMLElement).addEventListener('submit', this.handleSearch.bind(this));
    (this.dom.input as HTMLElement).addEventListener('input', this.handleInput.bind(this));
    (this.dom.input as HTMLElement).addEventListener('focus', this.handleInputFocus.bind(this));
    (this.dom.input as HTMLElement).addEventListener('blur', this.handleInputBlur.bind(this));
    (this.dom.eraseButton as HTMLElement).addEventListener('click', this.handleEraseInput.bind(this));
    (this.dom.desktopTrigger as HTMLElement).addEventListener('click', this.handleDesktopDropdownOpen.bind(this));
  }

  handleSearch(ev: Event) {
    ev.preventDefault();

    const value = (this.dom.input as HTMLInputElement).value;
    let redirectPath = '/search';

    if (this.el.dataset.redirectPath) {
      redirectPath = this.el.dataset.redirectPath;
    }

    if (value) {
      window.location.href = `${redirectPath}?keyword=${value}`;
    }
  }

  enableEraseButton() {
    (this.dom.submitButton as HTMLElement).classList.add('search-menu__button--hidden');
    (this.dom.eraseButton as HTMLElement).classList.remove('search-menu__button--hidden');
  }

  enableSubmitButton() {
    (this.dom.submitButton as HTMLElement).classList.remove('search-menu__button--hidden');
    (this.dom.eraseButton as HTMLElement).classList.add('search-menu__button--hidden');
  }

  handleEraseInput() {
    this.enableSubmitButton();
    (this.dom.input as HTMLElement).focus();
  }

  handleInput() {
    const value = (this.dom.input as HTMLInputElement).value;

    if (value) {
      this.enableEraseButton();
      return;
    }

    this.enableSubmitButton();
  }

  handleInputFocus() {
    this.el.classList.add('search-menu--focused');
  }

  handleInputBlur() {
    this.el.classList.remove('search-menu--focused');
  }

  handleDesktopDropdownOpen(ev: Event) {
    const trigger = ev.currentTarget as HTMLElement;
    if (this.el.classList.contains('search-menu--open')) {
      this.closeDropdown(trigger);
      return;
    }

    this.openDropdown(trigger);
  }

  openDropdown(trigger: HTMLElement) {
    this.el.classList.add('search-menu--open');
    trigger.setAttribute('aria-expanded', 'true');

    document.addEventListener('click', this.outsideClickListener);
    document.addEventListener('keydown', this.escapeKeyListener);
  }

  closeDropdown(trigger: HTMLElement) {
    this.el.classList.remove('search-menu--open');
    trigger.setAttribute('aria-expanded', 'false');

    document.removeEventListener('click', this.outsideClickListener);
    document.removeEventListener('keydown', this.escapeKeyListener);
  }

  handleEscapeKeyPress(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      const trigger = this.dom.desktopTrigger as HTMLElement;
      this.closeDropdown(trigger);
    }
  }

  handleOutsideClick(event: Event) {
    const isClickInside = this.el.contains(event.target as Node);
    if (!isClickInside) {
      const trigger = this.dom.desktopTrigger as HTMLElement;
      this.closeDropdown(trigger);
    }
  }
}

export default SearchMenu;